import {Expose, Type} from "class-transformer";
import {RequisitePsystemTargetType} from "@enums/RequisitePsystemTargetType";
import PaymentSystemCountry from "./PaymentSystemCountry";

export default class PaymentSystemOperation {
    @Expose({name: 'id'})
    private _id: number | null = null;

    @Expose({name: 'imgPath'})
    private _imgPath: string | null = null;

    @Expose({name: 'name'})
    private _name: string | null = null;

    @Expose({name: 'sysName'})
    private _sysName: string | null = null;

    @Expose({name: "targetType"})
    private _targetType: RequisitePsystemTargetType = RequisitePsystemTargetType.P2P;

    @Expose({name: 'country'})
    @Type(() => PaymentSystemCountry)
    private _country: PaymentSystemCountry = new PaymentSystemCountry();

    @Expose({name: "addressTypes"})
    private _addressTypes: number[] = [];

    constructor() {
    }

    get id(): number | null {
        return this._id;
    }

    get imgPath(): string | null {
        return this._imgPath;
    }

    get name(): string | null {
        return this._name;
    }

    set id(value: number) {
        this._id = value;
    }
    set imgPath(value: string) {
        this._imgPath = value;
    }
    set name(value: string) {
        this._name = value;
    }
    get sysName(): string | null {
        return this._sysName;
    }

    set sysName(value: string) {
        this._sysName = value;
    }
    get targetType(): RequisitePsystemTargetType {
        return this._targetType;
    }

    set targetType(value: RequisitePsystemTargetType) {
        this._targetType = value;
    }
    get addressTypes(): number[] {
        return this._addressTypes;
    }

    get country(): PaymentSystemCountry | null {
        return this._country;
    }

    set addressTypes(value: number[]) {
        this._addressTypes = value;
    }
}
